import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

const initialState = () => {
  return {
    module: 'pitches',
    model: 'pitch',
    loading: false,
    list: [],
    selectList: [],
    selected: {
      name: '',
      // photo: 'default-stadium.png',
      stadiumId: '',
      cameraId: '',
    },
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        name: item.name,
        stadium: item.stadiumId ? item.stadiumId.name : '-',
        camera: item.cameraId ? item.cameraId.name : '-',
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      if (item.photo) {
        if (item.photo.includes('http')) result.photo = item.photo
        else result.photo = process.env.VUE_APP_IMAGE_URL + item.photo
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchList({ commit, state, rootState }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }
    if (rootState.stadiums.idSelected) {
      body.stadiumId = rootState.stadiums.idSelected
    }
    if (state.selected.active !== undefined) body.active = 'all'

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module, body, { params: { ...query } })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async isCameraInUse({ state }, id) {
    const { data } = await apiAxios.get(`${state.module}/${id}/isCameraInUse`)
    return data.data || {}
  },
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
